export default __webpack_public_path__ + "static/media/belly.0eaf0e8e.jpg";